import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({

  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& ::-webkit-scrollbar': {
      width: '6px',
      height: '6px',
    },

    '& .MuiAlert-root': {
      alignItems: 'center'
    },

  },

  btnContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  btnOrange: {
    backgroundColor: '#ff9800 !important',
  },

  pdfContainer: {
    [theme.breakpoints.down('1100')]: {
      height: 'calc(100vh - 80px - 32px - 32px - 36px - 40px - 10px)',
    },
    height: '100%',

    '& > iframe': {
      border: 'none',
    }
  },

  main: {
    height: '100%',
    display: 'grid',
    gridTemplateColumns: '200px 1fr',
    maxHeight: 'calc(100% - 90px)',
    [theme.breakpoints.down('1100')]: {
      gridTemplateColumns: '0 1fr',
    }
  },
  aside: {
    [theme.breakpoints.down('1100')]: {
      opacity: 0,
    }
  },
  content: {
    width: '100%',
    textAlign: 'left',
    // display: 'flex',
    // flexDirection: 'column',
    display: 'grid',
    gridTemplateRows: 'auto 1fr auto',
    height: '100%',

  },
  card: {
    position: 'relative',
    width: 'calc(100vw - 80px)',
    maxWidth: '1500px',
    height: '100%',
    maxHeight: 'calc(100% - 70px)',
    padding: 16,
    boxShadow: '0px 3px 11px 0px rgba(0,0,0,0.75)',
    borderRadius: 10,


    '& h2': {
      marginTop: 0,
      [theme.breakpoints.down('1100')]: {
        marginBottom: 0,

      },
    },

    '& > div:first-child': {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      height: '100%',
    },

    display: 'grid',
    gridTemplateColumns: '3fr 2fr',
    transition: 'all .2s ease-in-out!important',

    '&[data-read-rules="false"]': {
      gridTemplateColumns: '1fr',
      maxWidth: '800px',
      '& > div:last-child': {
        display: 'none!important',
      },
    },

    '&[data-read-rules="true"]': {
      '& > div:last-child': {
        borderLeft: '1px solid rgba(0,0,0,.1)',
        marginLeft: 16,
        paddingLeft: 16,
      },
    },

    

    [theme.breakpoints.down('1100')]: {

      borderRadius: '0!important',
      height: 'auto',
      width: '100%',
      maxHeight: '100%',

      marginBottom: 0,
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto auto',

      '& > div:last-child': {
        border: 'none!important',
        marginLeft: '0!important',
        paddingLeft: '0!important',
      },
      '& > div:last-child > h3': {
        marginTop: '16px!important'
      },
    },


  },

  tabs: {
    textAlign: 'center',
    backgroundColor: theme.palette.primary.main,
    height: 48,
    flex: 'none',
    borderRadius: 8,
    display: 'flex',
    position: 'relative',
    boxShadow: 'rgb(0 0 0 / 10%) 0px 20px 25px, rgb(0 0 0 / 4%) 0px 10px 10px',

    '& button': {
      all: 'unset',
      position: 'relative',
      width: '100%',
      cursor: 'pointer',
      fontWeight: '500',
      color: 'rgba(255,255,255,.8)',

      '&.active': {
        color: 'white',

      }
    },
  },
  tab_indicator: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '50%',
    height: 2,
    display: 'flex',
    justifyContent: 'center',
    transition: 'all .3s ease-in-out',

    '&:before': {
      content: '""',
      backgroundColor: 'white',
      width: '70%',
    }
  },

  lists: {
    marginTop: 8,
    position: 'relative',

    '& > div': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%!important',
      transition: 'all .3s ease-in-out',

      '& > div': {
        height: '100%!important',
      },

      '.card-list': {
        height: '100%!important',
      }
    },

    '&.active-0': {
      '& > :first-child': {
        left: '0%'
      },
      '& > :last-child': {
        left: '100%'
      },

    },

    '&.active-1': {
      '& > :first-child': {
        left: '-100%'
      },
      '& > :last-child': {
        left: '0%'
      },
    },

  },

  VirtualizedList: {
    height: '100%'
  },


  radios: {
    height: '-webkit-fill-available',
    display: 'flex',
    gap: 16,

    '& input': {
      display: 'none',
    },

    '& > div label': {
      display: 'block',
      cursor: 'pointer',
      padding: '8px',
      width: '100%',
    },
    '& > div > button': {
      padding: 0,
      textAlign: 'center',
      width: 150,
      borderRadius: 12,
      border: 'none!important',
      backgroundColor: 'rgba(25, 118, 210, 0.1)',
      transition: 'all .2s ease-in-out',
    },
    '& > div > button:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.2)',
    },

    '& input:checked + button': {
      color: `white!important`,
      backgroundColor: theme.palette.primary.main
    },

    '& h3': {
      marginTop: 0,
    },

    '& p': {
      margin: 0,
      fontWeight: '400!important',
      textTransform: 'none',

    },
    '& p > span': {
      fontWeight: '600!important',
    },

    '& .prix': {
      fontSize: 30,
      fontWeight: 'bold!important',
      marginTop: '24px',
      marginBottom: '24px',
    },

    '& > div, & > div > button': {
      [theme.breakpoints.down('1100')]: {
        width: '100%'
      }
    },




  },

  info: {
    [theme.breakpoints.up('1100')]: {
      display: 'none'
    }
  },

  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: 600,
    padding: 16,

    '& .MuiListItemButton-root': {
      padding: 0,
    },

    '& .MuiListItemText-root': {
      borderBottom: '1px solid rgba(0,0,0,.1)',
      padding: '8px 16px',
      margin: 0,
    },

    '& > h3': {
      marginTop: 0,
      marginBottom: 16,
    },

    '& li > div': {
      padding: '8px 16px',
    },

    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      marginBottom: 8
    }
  },
  filters2: {
    marginTop: 8,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 8,
    '& > *': {
      height: '40px!important',
      justifyContent: 'inherit!important',
      borderRadius: '4px!important',
      '& .MuiChip-label': {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)'
      }
    }
  },

  active: {
    backgroundColor: `${theme.palette.primary.main}!important`,
    color: 'white!important',
  },

  divider: {
    margin: '16px 0',
    height: '1px',
    backgroundColor: 'rgba(0,0,0,.1)',
  },

  filters: {
    display: 'flex',
    gap: 8,
    marginTop: '16px',

    '& > div': {
      display: 'flex',
      flex: 'none',

      [theme.breakpoints.up('1100')]: {
        width: 'calc(50% - 4px)',
      },
      gap: 8,
      '& > *': {

        width: '100%',

      },
    },

    '& > .MuiFormControl-root': {
      width: 180,
      flex: 'none',
    },
    [theme.breakpoints.down('1100')]: {
      flexDirection: 'column'
    }
  },
  field: {
    position: 'relative',
    width: '-webkit-fill-available',

    [theme.breakpoints.down('1100')]: {
      marginBottom: '4px'
    },

    '& > svg': {
      width: 'auto',
      position: 'absolute',
      left: '12px',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    '& input': {
      paddingLeft: '48px!important',
    },
    '& label': {
      transition: 'all .2s ease-in-out!important',
    },
    '& [data-shrink="false"]:is(label)': {
      paddingLeft: '36px!important',
    },

    '&.full': {
      width: '100%',
    }
  },

  delete: {
    color: `${theme.palette.danger.main}!important`,
    transition: 'background-color ease .2s!important',

    '&:hover': {
      backgroundColor: `${theme.palette.danger.light}!important`,
    }
  },

  panierItem: {
    '& > span': {
      display: 'flex',
      justifyContent: 'space-between',
      marginRight: 16,
    }
  },

  panier: {
    overflowY: 'auto!important',
    maxHeight: '370px',


    ['@media only screen and (max-height: 700px)']: {
      maxHeight: '300px',
    },
    ['@media only screen and (max-height: 630px)']: {
      maxHeight: '250px',
    },
    ['@media only screen and (max-height: 580px)']: {
      maxHeight: '200px',
    },
    [theme.breakpoints.down('1100')]: {
      maxHeight: 'unset',
    },

    '& > div': {
      boxShadow: 'none',
      borderBottom: '1px solid rgba(0,0,0,.1)',
    }
  },

  rules: {
    height: '100%',
    overflowY: 'auto',
    textAlign: 'left',
    [theme.breakpoints.down('450')]: {
      height: '400px',
    },
  },

  listCrenaux: {
    height: 300,
    overflowY: 'auto',

    '& > *.red': {
      backgroundColor: 'rgba(255,0,0,.2)',
    },

    '& > *.orange': {
      backgroundColor: 'rgba(255,165,0,.2)',
    }
  },

  types: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
    transform: 'translate(8px, -8px)',
    '& > p': {
      height: '24px',
      padding: '0 8px',
      backgroundColor: '#ddd',
    },
    '& > p > span': {
      fontSize: '11px',
      padding: '0!important'
    }
  },


  basketIcon: {
    '& > div': {
      position: 'relative',

      '& > div': {
        position: 'absolute',
        top: -10,
        right: -10,
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        width: 20,
        height: 20,
        borderRadius: 99,
        display: 'grid',
        placeItems: 'center',
        fontSize: 12,
      },
    },
    '&:not(:disabled) > div > svg': {
      fill: 'rgba(0, 0, 0, 0.87)'
    }
  },


  barred: {
    position: 'relative',
    color: '#777',
    '&:before': {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: 2,
      backgroundColor: 'currentColor',
      top: '30%',
      left: '50%',
      transform: 'rotate(-20deg) translate(-50%, -50%)'
    }
  }
}))
